/**
 * Sign-in OTP (S02) — verify the 6-digit code, dispatch by membership state.
 *
 * @see prototype/onboarding/otp.html — V1.1 Studio Slate baseline
 */
import { createFileRoute, Link } from "@tanstack/react-router";
import {
  OnboardingShell,
  OnboardingHeader,
  Stepper,
  Hero,
  HeroNote,
  BrandFor,
  STEP_TITLES,
} from "../../../features/onboarding/components/index.ts";
import { ChevronLeft, Info } from "lucide-react";
import { OtpForm } from "../../../features/onboarding/components/otp-form.tsx";
import { useOnboardingFlow } from "../../../features/onboarding/lib/flow-state.ts";

export const Route = createFileRoute("/(auth)/sign-in/otp")({
  component: SignInOtp,
});

function SignInOtp() {
  const phone = useOnboardingFlow((s) => s.phone);
  const phoneDisplay = phone ? `+91 ${phone.slice(0, 5)} ${phone.slice(5)}` : "your phone";

  return (
    <OnboardingShell
      header={
        <OnboardingHeader
          center={<Stepper current={2} titles={STEP_TITLES} />}
          right={
            <Link
              to="/sign-in"
              className="inline-flex items-center gap-1 text-xs text-muted hover:text-ink-2"
            >
              <ChevronLeft size={14} />
              <span>Change number</span>
            </Link>
          }
        />
      }
      brand={<BrandFor step="otp" />}
      footer="OTP verification first · workspace creation or sign-in comes next"
    >
      <Hero
        kicker="Phone verification"
        title="Enter the 6-digit code."
        description={
          <>
            We sent a code to <span className="font-mono tabular-nums">{phoneDisplay}</span>. Once
            this phone is verified, Flint can open your company, accept an invite, or start a new
            workspace.
          </>
        }
      >
        <HeroNote icon={<Info size={10} />}>
          Single-use verification keeps first access light without weakening later approvals.
        </HeroNote>
      </Hero>
      <OtpForm />
    </OnboardingShell>
  );
}
